<div #contentHost
     class="eva-list"
     [innerHTML]="parsedResponse()"></div>

<ng-template #linkTemplate
             let-link
             let-linkId="linkId">
  @if (link?.openInNew) {
    <!-- Link to opened in new tab: plain inline anchor opening in a new tab, matching the pre-popover behaviour. -->
    <a class="eva-source-link"
       [ezRouterLink]="link.url"
       target="_blank"
       rel="noopener noreferrer"
       (click)="triggerMetricsTracking(link)">
      {{ link.text }}
      <mat-icon small>open_in_new</mat-icon>
    </a>
  } @else {
    <button [matButton]="openLinkId() === linkId ? 'filled' : 'tonal'"
            color="primary"
            class="source-trigger"
            [ezPopover]="linkId"
            #sourceTrigger="ezPopover">
      <mat-icon small>link</mat-icon>
      {{ link.text }}
    </button>
    <div popover
         [id]="linkId"
         (toggle)="onPopoverToggle($event, link, linkId)">
      <ez-source-popover [sourceText]="sourceMetadata()[linkId]?.sourceText ?? link.text"
                         [url]="link.url"
                         [message]="sourceMetadata()[linkId] ? sourceMetadata()[linkId]?.message : loadingMessage"
                         [sourceName]="link.sourceName ?? ''"
                         (sourceClicked)="onLinkClicked(sourceTrigger, link)"
                         [openInNew]="link?.openInNew" />
    </div>
  }
</ng-template>